import Row from './Row.template'

export default Row
